import defaultTrans from './locales/en-US.json';

/**
 * FALLBACK_LOCALE - **MUST** match the locale string in the above import
 */
export const FALLBACK_LOCALE = 'en-US';

export const defaultTranslation = defaultTrans;
